module.exports = __webpack_public_path__ + "static/media/intro.e7acd699.mp3";